<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>
<template>
	<div class="data-list-container">
		<div class="header report-form-config__header flex justify-between mb-8 flex-wrap">
			<div class="header__navigation flex items-center">
				<h3>{{ $t("Report") }}</h3>
			</div>
		</div>
		<vs-table ref="table" class="stack-table" :sst="true" :data="kcsList" :max-items="limit" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="w-full grid grid-cols-2">
				<div class="header report-form-config__header flex justify-between flex-wrap">
					<div class="header__navigation flex items-center">
						<i class="nucleo nucleo-arrow-left text-black text-3xl mr-6 sm:mr-12 cursor-pointer" @click="$router.go(-2)"></i>
						<h3>KCS</h3>
					</div>
				</div>
				<div class="flex justify-end">
					<vs-input
						@input="mixinHandleSearch"
						size="large"
						class="input-search mr-3 md:block lg:block xl:block hidden"
						icon="search"
						:placeholder="$t('Actions.Search')"
						v-model="searchText"
					/>
					<div class="md:flex lg:flex xl:flex hidden">
						<vs-button v-if="mixinIsCanCreateProductStock" class="w-30 font-bold mr-3" @click="addProductStock">{{ $t("Actions.Create") }}</vs-button>
					</div>
				</div>
			</div>

			<template slot="thead">
				<vs-th class="product">{{ $t("Product") }}</vs-th>
				<vs-th sort-key="inventory">{{ $t("Inventory") }}</vs-th>
				<vs-th sort-key="name" class="custom-sort-filter">{{ $t("Location") }}</vs-th>
				<vs-th sort-key="limit">{{ $t("LotNumber") }}</vs-th>
				<vs-th sort-key="expired_days">{{ $t("DateAdded") }}</vs-th>
				<vs-th sort-key="quantity">{{ $t("Numbers") }}</vs-th>
				<vs-th sort-key="qty_limit">{{ $t("ExpiredDays") }}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Product')" class="md:text-center">
							<p class="text-left">{{ tr.product && tr.product.name }}</p>
						</vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Inventory')">
							<p>{{ tr.inventory && tr.inventory.name }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Location')">
							<p class="text-base">{{ tr.bin }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('LotNumber')">
							<p class="text-base">{{ tr.lot_number }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('DateAdded')">
							<p class="text-base">{{ tr.imported_at | dateTime("DD/MM/YYYY") }}</p>
						</vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Numbers')">
							<p class="text-base text-right">{{ $helper.numFormat(tr.quantity) }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('ExpiredDays')">
							<p class="text-base text-right">{{ $helper.numFormat(tr.expired_days) }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<KCSContextMenu type="vertical" :kcsItem="tr" @onClickExport="handleExport" @onClickEdit="handleEdit" @onClickDelete="showDeleteConfirm" />
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
		<KSCForm :isSidebarActive="isShowProductStockForm" :kcsItem="kcsDialogData" @closeSidebar="toggleProductStockForm" />
	</div>
</template>

<script>
import { withBasicQueries, productPermissions, stockCardPermissions, getUserPermissions, productStockPermissions } from "@/mixins/mixins.js";
import KCSContextMenu from "./KCSContextMenu.vue";
import KSCForm from "./../customer/KSCForm.vue";
import moduleInventory from "@/store/inventory/moduleInventory";

export default {
	components: {
		KCSContextMenu,
		KSCForm
	},
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...productPermissions,
			...stockCardPermissions,
			...productStockPermissions
		})
	],
	computed: {
		kcsList() {
			return this.$store.state.inventoryManagement.kcsList;
		},
		totalPages() {
			return Math.ceil(this.$store.state.inventoryManagement.totalKCS / this.limit);
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			searchText: "",
			detailProductDialogData: {},
			isDetailProductDialogActive: false,
			kcsDialogData: {},
			isShowProductStockForm: false
		};
	},
	watch: {
		page() {
			this.getKCSList();
		},
		"$route.query"() {
			this.getKCSList();
		}
	},
	methods: {
		async getKCSList() {
			this.$vs.loading();
			await this.$store.dispatch("inventoryManagement/fetchListKCS", {
				page: this.page,
				search: this.searchText,
				limit: this.limit
			});
			this.$vs.loading.close();
		},

		handleClickItemRow(event, product) {
			this.detailProductDialogData = product;
			this.toggleProductDetailSidebar(true);
		},
		toggleProductDetailSidebar(val) {
			this.isDetailProductDialogActive = val ? val : false;
		},

		handleExport(kcs) {
			console.log("handleExport", kcs);
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: `${kcs.product && kcs.product.name} (${kcs.lot_number}) đã được xuất kho hết?`,
				accept: () => this.exportProductStock(kcs),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async exportProductStock(kcsItem) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("inventoryManagement/exportProductStock", kcsItem.id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("Actions.ExportAll")} ${this.$t("Successful").toLowerCase()}`
					}
				});
				if (this.isDetailProductDialogActive) {
					this.toggleProductDetailSidebar(false);
				}
			} catch (error) {
				console.error("ERR handleExport", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		handleEdit(product) {
			console.log("handleEdit", product);
			this.kcsDialogData = product;
			this.toggleProductStockForm(true);
		},
		async handleDelete(kcs) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("inventoryManagement/deleteProductStock", kcs.id);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: `${this.$t("Actions.Delete")} ${this.$t("Successful").toLowerCase()}`
					}
				});
				if (this.isDetailProductDialogActive) {
					this.toggleProductDetailSidebar(false);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		showDeleteConfirm(prod) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.handleDelete(prod),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},

		addProductStock() {
			this.kcsDialogData = {};
			this.toggleProductStockForm(true);
		},
		toggleProductStockForm(val = false) {
			this.isShowProductStockForm = val;
		},
		refreshProductList() {
			this.page = 1;
			this.getKCSList();
		}
	},
	created() {
		this.$store.registerModule("inventoryManagement", moduleInventory);
		this.getKCSList();
	},
	beforeDestroy() {
		this.$store.unregisterModule("inventoryManagement");
	}
};
</script>

<style></style>
